import { MutationTree } from 'vuex'

import {
  CarereceiverPageData,
  CarereceiverProfileDTO,
  CarereceiverState,
  Mutations,
} from './types'

const mutations: MutationTree<CarereceiverState> = {
  [Mutations.SET_CARERECEIVER_PROFILE](state, value) {
    state.carereceiverProfilePageData = value
  },

  [Mutations.SET_CARERECEIVER_FROM_BE](
    state,
    carereceiverProfile: CarereceiverProfileDTO,
  ) {
    const {
      relationship,
      salutation,
      name,
      age,
      address,
      care_degree,
      description,
    } = carereceiverProfile

    const mappedCarereceiverProfile: CarereceiverPageData = {
      needHelp: relationship,
      gender: salutation,
      firstName: name.first_name,
      lastName: name.last_name,
      age,
      street: address.street,
      houseNumber: address.house_number,
      postcode: address.postal_code.toString(),
      city: address.city,
      additionalAddressInformation: address.additional_information,
      careDegree: care_degree,
      careReceiverDescription: description,
    }

    state.carereceiverProfilePageData = mappedCarereceiverProfile
  },

  [Mutations.SET_CARERECEIVER_ID_FOR_CURRENT_BOOKING_FUNNEL](
    state,
    crId: string,
  ) {
    state.careReceiverIdForCurrentBookingFunnel = crId
  },
}

export default mutations
